<script>
  /**
 *
 *
 *
 *
 *
 */

  import SponsoredBadge from './SponsoredBadge.svelte';
  import { key as featureWidthAlignmentWithCinemas } from '../context/featureWidthAlignmentWithCinemas.js';
  import { getContext } from 'svelte';

  /*                */
  let { image, deal = null, lazyLoad = false, isVeryPopular = false } = $props();

  const { widthAmount } = getContext(featureWidthAlignmentWithCinemas);
  const columnHorizontalPaddings = 32;
  const width = `${widthAmount - columnHorizontalPaddings}px`;
  const height = `${(4 / 3) * (widthAmount - columnHorizontalPaddings)}px`;

  const MEDIUM_IMAGE_SIZE_PRESET = '$spa_ambiente$';
  const TILE_PORTRAIT_PRESET = '$tile_portrait$';
  const loadingValue = lazyLoad ? 'lazy' : 'eager';

  const buildImageUrl = (imageUrl, clippingType) => {
    const prefix = clippingType === 'AMBIENTE' ? MEDIUM_IMAGE_SIZE_PRESET : TILE_PORTRAIT_PRESET;
    return imageUrl + '?' + prefix;
  };

  const imageSrc = buildImageUrl(image._links.external.href, image.clippingType);

  const showSponsored = deal?.imageUrl && deal?.clickable;
  const showDealIcon = deal?.imageUrl && !deal?.clickable;
</script>

<div class="reco_comparison__image pl_card" style:width style:height>
  <picture>
    <source srcset="{imageSrc}&fmt=auto" />
    <img
      loading={loadingValue}
      data-src={imageSrc}
      src={lazyLoad ? '' : imageSrc}
      alt={image.altText}
      class="{lazyLoad ? 'lazy' : ''} {image.clippingType === 'AMBIENTE' ? 'ambiente' : 'cutout'}"
      data-testid="image-title" />
  </picture>
  <div class="reco_comparison__image__spinner_box">
    <div class="reco_comparison__image__spinner {lazyLoad ? 'p_loader250' : ''}"></div>
  </div>
  {#if showSponsored}
    <SponsoredBadge {deal} />
  {:else if showDealIcon}
    <div
      role="paragraph"
      class="reco_comparison__image__badge reco_comparison__image__deal_badge"
      data-qa="dealIcon"
      style={'background: url(' + deal.imageUrl + ') center center/50px 50px no-repeat;'}>
      &nbsp;
    </div>
  {/if}
  <div class="reco_comparison__labels_wrapper">
    {#if isVeryPopular}
      <div class="reco_comparison__label-visibility reco_comparison__very-popular-tag">
        <oc-tag-v1 size="50" variant="info-primary">Sehr beliebt</oc-tag-v1>
      </div>
    {/if}
  </div>
</div>

<style lang="scss">
  .reco_comparison__image {
    text-align: center;
    padding-bottom: initial;
    position: relative;
    overflow: hidden;
    max-height: 100%;
    max-width: 100%;
    transform: translateZ(0);
    border-radius: 8px;

    img {
      max-width: 100%;
      max-height: 100%;
      z-index: 1;
      position: absolute;
      right: 50%;
      transform: translate(50%, 0);
    }

    img.ambiente {
      width: auto;
      height: auto;
      min-width: 100%;
      min-height: 100%;
      max-width: none;
    }

    img.cutout {
      padding: 8px;
      width: 100%;
    }
  }

  .reco_comparison__image__spinner_box {
    position: absolute;
    margin: auto;
    width: 60px;
    height: 60px;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 0;
  }

  .reco_comparison__image__deal_badge {
    position: absolute;
    width: 50px;
    height: 50px;
    z-index: 1;
    top: 8px;
    left: 16px;
  }

  /*                                                                                                                  */
  .reco_comparison__image__badge {
    background-size: cover;
  }

  .reco_comparison__labels_wrapper {
    display: flex;
    flex-direction: column;
    position: absolute;
    bottom: 16px;
    left: 16px;
    flex-wrap: wrap;
    align-items: flex-start;
  }

  .reco_comparison__label-visibility {
    z-index: 1;
  }

  .reco_comparison__very-popular-tag {
    margin-top: 8px;
  }
</style>
